export const CHECKOUT_MATOMO_EVENT_CATEGORY_PURCHASE = 'Purchase';
export const CHECKOUT_MATOMO_EVENT_CATEGORY_PERSONALIZATION = 'Personalization';
